export const environment = {
  production: true,
  API_URL: "https://uat.portal.backend.alicrosas.com/api/",
  lmsBaseUrl: 'https://uat.portal.backend.alicrosas.com',
  version: "6.6.0 (UAT-ALICRO)"
};
